__webpack_require__.p = "https://kitchen.tchop.co/";